import { Component, DestroyRef, ElementRef, inject, TemplateRef, ViewChild } from '@angular/core';
import { BreadcrumbComponent } from '../../elements/breadcrumb/breadcrumb.component';
import { ActivatedRoute, Router, RouterModule } from '@angular/router';
import { Subscription } from 'rxjs';
import { MatTabsModule } from '@angular/material/tabs';
import { NgClass, NgFor, NgIf } from '@angular/common';
import { NgbCarouselModule, NgbModal, NgbModalRef, NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { PropertyBillsComponent } from '../property-bills/property-bills.component';
import { LoadingService } from '../../services/loading.service';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { PropertyLeaseComponent } from '../property-lease/property-lease.component';
import { HttpServiceService } from '../../services/http-service.service';
import { NgxToastrService } from '../../_services/ngx-toastr/ngx-toastr.service';
import { Offcanvas } from 'bootstrap';
import { APP_CONSTANTS, USER_PERMISSIONS } from '../../app.constants';
import { LocalStorageService } from '../../services/local-storage.service';
// import { DefaultImageDirective } from '../../directives/default-image.directive';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { CommonModule, DatePipe } from '@angular/common';
import { EnquiriesListComponent } from '../../enquiries/enquiries-list/enquiries-list.component';
import { PropertyBuyersComponent } from '../property-buyers/property-buyers.component';
import { TasksListComponent } from '../../tasks/tasks-list/tasks-list.component';

@Component({
  selector: 'app-properties-view',
  imports: [
    BreadcrumbComponent,
    RouterModule,
    MatTabsModule,
    NgFor,
    NgClass,
    NgbModule,
    PropertyBillsComponent,
    ReactiveFormsModule,
    PropertyLeaseComponent,
    NgbCarouselModule,
    CommonModule,
    DatePipe,
    EnquiriesListComponent,
    PropertyBuyersComponent,
    TasksListComponent
  ],
  templateUrl: './properties-view.component.html',
  styleUrl: './properties-view.component.css'
})
export class PropertiesViewComponent {
  breadcrumbList = {
    breadcrumb_path: 'Properties',
    currentURL: 'Property View',
    breadcrumb_url: '/admin/properties/properties-list'
  }
  @ViewChild(PropertyBillsComponent) propertyBills!: PropertyBillsComponent;
  @ViewChild('viewBillBlock') viewBillBlock! : ElementRef;
  @ViewChild('addEditBillButton') offcanvas!: ElementRef;
  private offcanvasInstance: Offcanvas | null = null;
  @ViewChild('add_documents_popup') addDocumentsPopup!: ElementRef;
  private addDocumentsInstance: Offcanvas | null = null;

  active = 1;
  propertyId: string = '';
  private routeSubscription?: Subscription;
  theme: any = [{ hedingClass: 'accordion-primary' }];
  themeClass: any = '';
  maneClass: string = '';
  positionClass: string = '';
  iconClass: string = '';
  bg: string = '';
  loadingService = inject(LoadingService);
  addBillsForm!: FormGroup;
  addDocumentForm!: FormGroup;
  addLeaseForm!: FormGroup;
  add_property_bills: boolean = false;
  add_documents: boolean = false;
  billTypes: any = [];
  bankAccounts: any[] = [];
  getCategoriesSubscription?: Subscription;
  getBankAccountsSubscription?: Subscription;
  addBillSubscription?: Subscription;
  selectedFiles: File[] = [];
  isEditBill: boolean = false;
  getBillDetailsSubscription? : Subscription;
  uploadedImages : any = [];
  private modalService= inject(NgbModal);
  displayImage : string = '';
  private editBillSubscription?: Subscription;
  private deleteBillImageSubscription? : Subscription;
  private getBillImagesSubscription? : Subscription;
  private addDocumentSubscription? : Subscription;
  private getAllDocumentsSubscription? : Subscription;
  private deleteDocumentSubscription? : Subscription;
  total_amount : any = 0;
  allBills : any;
  billModalRefs: any;
  imageModalRefs : any;
  imagePopupRefs : any;
  view_bill_details : boolean = false;
  propertyDocuments : any = [];
  propertyImages : any = [];
  private getAllPropertyImagesSubscription?: Subscription;
  private getPropertyDetailsByIdSubscription?:Subscription;
  private getAllPropertyRoomsSubscription?: Subscription;
  private initiatePaymentSubscription? : Subscription;
  private verifyPaymentSubscription? : Subscription;
  private authService = inject(LocalStorageService);
  propertyRoomsList : any = [];
  selectedProperty : any = [];
  defaultBillTypes : any=  [{ key : 1, keyName : "Rent/Security Deposit"}, { key : 2, keyName : "Expenses"},{ key : 3, keyName : "Company Fee"}];
  private queryParamsData : any;
  private queryParamsSubsscription? : Subscription;
  private destroyRef = inject(DestroyRef);

  constructor(private route: ActivatedRoute, private router: Router, private fb: FormBuilder, private httpService: HttpServiceService, private alertService: NgxToastrService) {
    this.routeSubscription = this.route.paramMap.subscribe(params => {
      this.propertyId = params.get('id') ?? "";
      this.active = params.get('activeId') ? parseInt(params.get('activeId') ?? "") : this.active;
    });
    this.addBillsForm = this.fb.group({
      name: ['', Validators.required],
      bill_type: [null, Validators.required],
      bill_category_id: [null, Validators.required],
      bank_account_id: [null],
      amount: ['', Validators.required],
      details: [''],
      files: [null],
      tenant_visibility: [false, Validators.required],
      payment_mode: [null],
      uid : [''],
      status: [null],
      taxable : [false],
      auto_invoice : [false],
      sgst_per : [0],
      cgst_per : [0],
      discount_per : [0],
      transaction_id: [''],
      paid_date: [''],
      invoice_date: [null],
    });
    this.addDocumentForm = this.fb.group({
      document: ['', [Validators.required]],
      name: ['', [Validators.required]],
      document_type: [null, [Validators.required]],
      description: [''],
      tenant_visible : [false],
      owner_visible : [false]
    });
    this.addLeaseForm = this.fb.group({
      lease_rent: ['', [Validators.required]],
      security_deposit: ['', [Validators.required]],
      rental_agreement_date: ['', [Validators.required]],
      tenant_moving_out_date: ['', [Validators.required]],
      lease_start_date: ['', [Validators.required]],
      lease_end_date: ['', [Validators.required]],
      leaving_reason: [''],
      lease_yearly_increment: ['', [Validators.required]],
      lease_document: [''],
      tenants: ['']
    })
  }

  editPropertyEvent(value: boolean) {
    this.router.navigate(['/admin/properties/property-edit', this.propertyId],{
      queryParams : this.queryParamsData
    });
  }

  ngOnInit() {
    if (this.theme && this.theme.length > 0) {
      this.themeClass = this.theme[0];
      this.maneClass = this.theme[0].hedingClass;
      this.positionClass = this.theme[0].postion;
      this.iconClass = this.theme[0].icon;
      this.bg = this.theme[0].bg;
    }
    this.addBillsForm.get('bill_type')?.valueChanges.pipe(takeUntilDestroyed(this.destroyRef)).subscribe((billType: number) => {
      this.billTypes = [];
      this.addBillsForm.get('bill_category_id')?.setValue(null);
      if (billType) this.getCategory(billType);
    });
    let id = this.route.snapshot.paramMap.get('id')!;
    this.getPropertyDetailsById(id);
    this.getAllDocuments();
    this.getAllPropertyImages();
    this.getAllPropertyRooms();
    this.loadBankAccounts();

    // Bank account is only required when the bill is taxable. Mirror the
    // server-side conditional validation by toggling the Required validator
    // on bank_account_id whenever the taxable flag changes.
    this.addBillsForm.get('taxable')?.valueChanges.pipe(takeUntilDestroyed(this.destroyRef)).subscribe((isTaxable: boolean) => {
      const bankAccountControl = this.addBillsForm.get('bank_account_id');
      if (isTaxable) bankAccountControl?.setValidators([Validators.required]);
      else bankAccountControl?.clearValidators();
      bankAccountControl?.updateValueAndValidity({ emitEvent: false });
    });

    this.addBillsForm.get('taxable_bill')?.valueChanges.pipe(takeUntilDestroyed(this.destroyRef)).subscribe((isTaxable: boolean) => {
    const sgstControl = this.addBillsForm.get('sgst_per');
    const cgstControl = this.addBillsForm.get('cgst_per');
    const invoiceDateControl = this.addBillsForm.get('invoice_date');

    if (isTaxable) {
      sgstControl?.setValidators([Validators.required, Validators.max(15)]);
      cgstControl?.setValidators([Validators.required, Validators.max(15)]);
      this.updateInvoiceDateValidation();
    } else {
      sgstControl?.clearValidators();
      sgstControl?.setValue('');

      cgstControl?.clearValidators();
      cgstControl?.setValue('');

      invoiceDateControl?.clearValidators();
      invoiceDateControl?.setValue(null);
    }
    sgstControl?.updateValueAndValidity();
    cgstControl?.updateValueAndValidity();
    invoiceDateControl?.updateValueAndValidity();
  });

  this.addBillsForm.get('status')?.valueChanges.pipe(takeUntilDestroyed(this.destroyRef)).subscribe(() => {
    this.updateInvoiceDateValidation();
  });

  this.queryParamsSubsscription = this.route.queryParams.subscribe((data: any)=> {
      this.queryParamsData = data;
  });

  }

  ngAfterViewInit() {
      setTimeout(() => {
        const offcanvasElement = this.offcanvas?.nativeElement;
        if (offcanvasElement) {
          this.offcanvasInstance = Offcanvas.getOrCreateInstance(offcanvasElement, {
            backdrop: 'static',
            keyboard: false,
          });
        }
        const addDocumentElement = this.addDocumentsPopup?.nativeElement;
        if (addDocumentElement) {
          this.addDocumentsInstance = Offcanvas.getOrCreateInstance(addDocumentElement, {
            backdrop: 'static',
            keyboard: false,
          });
        }
      });
  }

  viewPropertyImage(content: TemplateRef<any>){
      this.imagePopupRefs = this.modalService.open(content, { centered: true,  backdrop: 'static' });
  }

  closeImageModal(){
    this.imagePopupRefs.close();
  }

  getAllPropertyImages(){
    this.getAllPropertyImagesSubscription = this.httpService.getAllPropertyImages(this.propertyId).subscribe({
      next : (response) => {
        this.propertyImages = response.data;
      }
    })
  }

  /**
   * property_category is a JSON map of checkbox key → true. Keep this list in
   * sync with the checkboxes on the property edit form; a category missing
   * here silently disappears from the details page.
   */
  private static readonly PROPERTY_CATEGORY_LABELS: { key: string; label: string }[] = [
    { key: 'property_category_sale', label: 'Sale' },
    { key: 'property_category_rent', label: 'End-to-End Management' },
    { key: 'property_category_property_management', label: 'Property Management' },
    { key: 'property_category_tenant_placement', label: 'Tenant Placement' },
    { key: 'property_category_plot_monitoring', label: 'Plot Monitoring' },
    { key: 'property_category_repairs_renovation', label: 'Repairs & Renovation' },
    { key: 'property_category_documentation', label: 'Documentation' },
  ];

  /** Labels of the categories ticked on the selected property. */
  get propertyCategoryLabels(): string[] {
    const category = this.selectedProperty?.property_category;
    if (!category) return [];
    return PropertiesViewComponent.PROPERTY_CATEGORY_LABELS
      .filter(({ key }) => category[key] === true || category[key] === 'true')
      .map(({ label }) => label);
  }

  getPropertyDetailsById(uid: string) {
    this.getPropertyDetailsByIdSubscription = this.httpService.getPropertyDetailsById(uid).subscribe({
      next: (response) => {
        let data = response.data;
        if(data?.property_category){
          data.property_category = data.property_category;
        }
        this.selectedProperty = data;
      }
    })
  }

  getAllPropertyRooms(){
    this.getAllPropertyRoomsSubscription = this.httpService.getAllPropertyRooms(this.propertyId).subscribe({
      next : (response) => {
        this.propertyRoomsList = response.data;
      }
    })
  }


  onSubmit() {

  }

  updateBillValue(){
    this.add_property_bills = !this.add_property_bills;
  }

  addPropertyBills() {
    this.updateBillValue();
    this.isEditBill = false;
    if (this.offcanvasInstance) {
        this.offcanvasInstance.show();
    }
  }

  viewBillDetails(){
    this.view_bill_details = !this.view_bill_details;
    this.isEditBill = false;
  }

  addPropertyBillsClose() {
    this.uploadedImages = [];
    this.updateBillValue();
    this.addBillsForm.reset({
      tenant_visibility : false,
      taxable : false,
      auto_invoice : false
    });
    if (this.offcanvasInstance) {
        this.offcanvasInstance.hide();
    }
  }

  uploadBills(event: Event) {
    const inputElement = event.target as HTMLInputElement;
    if (inputElement.files) {
      this.selectedFiles = Array.from(inputElement.files);
    }

  }

  backToProperties(event : any){
    this.router.navigate([this.breadcrumbList.breadcrumb_url], {
      queryParams : this.queryParamsData
    });
  }

  saveBill() {
    if (!this.addBillsForm.valid) return;
    let billId  = this.addBillsForm.get("uid")?.value ?? "";
    const formData = new FormData();
    this.selectedFiles.forEach((file, index) => {
      formData.append('files', file); // 'images' is the form field name
    });
    if(this.isEditBill){
      Object.keys(this.addBillsForm.controls).forEach((key) => {
        if (key != "files" && key !="uid") {
          let value = this.addBillsForm.get(key)?.value;
          if(key == "discount_per" && !value){
            value  = 0;
          }
          if((key == "taxable" && !value) || (key == "auto_invoice" && !value)){
            value  = false;
          }
          // FormData.append turns null/undefined into the literal string
          // "null"/"undefined", which breaks server-side Joi validation
          // (e.g. bank_account_id must be a valid GUID). Skip those.
          if (value === null || value === undefined) return;
          formData.append(key, value);
        }
      });
      this.editBillSubscription = this.httpService.editBill(formData, this.propertyId, billId).subscribe({
        next: (response) => {
          this.addPropertyBillsClose();
          this.propertyBills.getAllBills();
          this.alertService.success(response.message, "toast-top-right");
          this.selectedFiles = [];
        }
      })

    }else{
      Object.keys(this.addBillsForm.controls).forEach((key) => {
        if (key != "files" && key != "status" && key !="uid" && key !="payment_mode") {
          let value = this.addBillsForm.get(key)?.value;
          if(key == "discount_per" && !value){
            value  = 0;
          }
          // FormData.append turns null/undefined into the literal string
          // "null"/"undefined", which breaks server-side Joi validation
          // (e.g. bank_account_id must be a valid GUID). Skip those.
          if (value === null || value === undefined) return;
          formData.append(key, value);
        }
      });
      this.addBillSubscription = this.httpService.addBill(formData, this.propertyId).subscribe({
        next: (response) => {
          this.alertService.success(response.message, "toast-top-right");
          this.propertyBills.getAllBills();
          this.addPropertyBillsClose();
          this.addBillsForm.reset({
            tenant_visibility: false,
            taxable: false,
            auto_invoice: false
          });
          this.selectedFiles = [];
        }
      })
    }


  }

  editBill(billId: string, type : string = '') {
    this.getBillDetailsSubscription = this.httpService.getBillDetailsById(this.propertyId, billId).subscribe({
      next : (response) => {
        this.allBills = response["data"];
        if(type){
          // this.billModalRefs = this.modalService.open(this.viewBillBlock, { size: 'lg', backdrop: 'static' });
          this.viewBillDetails();
        }
        if(!type){
          this.uploadedImages = response["data"]?.["uploads"] ?? [];
          this.addBillsForm.patchValue(response["data"]);
          this.addBillsForm.patchValue({
            bank_account_id: response["data"]?.bank_account?.id ?? null,
          });
          this.calculateTotal();
          this.addPropertyBills();
          this.isEditBill = true;
        }
      }
    });
  }

  viewBill(billId : string){
    this.editBill(billId, 'viewBill');
  }

  viewImage(imageUrl : string){
    this.getBillImagesSubscription = this.httpService.getBillImages(imageUrl).subscribe({
      next : (response) => {
        window.open(response.data["url"] , "_blank");
      }
    })
  }

  updateTenantVisibility(){
    let billTo = this.addBillsForm.get("role_identifier")?.value ?? "";
    let tenantCtrl = this.addBillsForm.get('tenant_visibility');
    if(billTo == "tenant"){
       tenantCtrl?.setValue(true);
       tenantCtrl?.disable();
    }else{
       if(tenantCtrl?.disabled){
         tenantCtrl?.setValue(false);
         tenantCtrl?.enable();
       }
    }
  }

  openCenter(content: TemplateRef<any>, url: string) {
    this.displayImage = url;
    this.imageModalRefs = this.modalService.open(content, { centered: true, backdrop: 'static' });
  }

  closeModal() {
    this.imageModalRefs.close();
  }

  closeBillModal(){
    this.billModalRefs.close();
  }


  deleteImage(uid : string){
    let billId  = this.addBillsForm.get("uid")?.value ?? "";
    this.deleteBillImageSubscription = this.httpService.deleteBillImage(this.propertyId, billId, uid).subscribe({
      next : (response) => {
        this.uploadedImages  = this.uploadedImages.filter((img: { uid: string; }) => img.uid !=uid);
        this.alertService.success(response.message, "toast-top-right");
      }
    })
  }

  addDocuments() {
    this.add_documents = !this.add_documents;
    if (this.addDocumentsInstance) {
        this.addDocumentsInstance.show();
    }
  }

  addDocumentClose() {
    this.addDocuments();
    this.addDocumentForm.reset();
    if(this.addDocumentsInstance) {
        this.addDocumentsInstance.hide();
    }
  }

  submitDocument(){
    if(!this.addDocumentForm.valid) return;
    const formData = new FormData();
    Object.keys(this.addDocumentForm.controls).forEach((key) => {
        formData.append(key, this.addDocumentForm.get(key)?.value);
    });
    this.addDocumentSubscription = this.httpService.addDocument(formData, this.propertyId).subscribe({
        next : (response) => {
          this.getAllDocuments();
          this.addDocumentClose();
          this.addDocumentForm.reset();
          this.alertService.success(response.message, "toast-top-right");
        }
      });
  }

  getAllDocuments(){
    this.getAllDocumentsSubscription = this.httpService.getAllPropertyDocuments(this.propertyId).subscribe({
      next : (response) => {
        this.propertyDocuments = response.data;
      }
    })
  }

  deletePropertyDocument(uid : string){
    this.deleteDocumentSubscription = this.httpService.deletePropertyDocument(uid, this.propertyId).subscribe({
      next : (response) => {
        this.getAllDocuments();
        this.alertService.success(response.message, "toast-top-right");
      }
    })
  }

  onImageChange(event: any) {
    const file = event.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onload = () => {
        //this.selectedImage = reader.result; // Store preview image
      };
      reader.readAsDataURL(file);

      this.addDocumentForm.patchValue({ document: file });
      this.addDocumentForm.get('document')?.updateValueAndValidity();
    }
  }

  getCategory(billType: number = 0) {
    this.getCategoriesSubscription = this.httpService.getBillCategories(billType).subscribe({
      next: (response) => {
        this.billTypes = response["data"];
      }
    });
  }

  loadBankAccounts() {
    this.getBankAccountsSubscription = this.httpService.getBankAccounts(1, 200).subscribe({
      next: (response) => {
        this.bankAccounts = response?.data?.bank_accounts ?? [];
      }
    });
  }

  // Invoice-ID format of the bank selected on the bill form (informational
  // hint; the ID itself is generated server-side).
  get selectedBankInvoiceFormat(): string | null {
    const id = this.addBillsForm?.get('bank_account_id')?.value;
    if (!id) return null;
    const account = this.bankAccounts?.find((acc) => acc.id === id);
    return account?.invoice_format || null;
  }

  showTotal(){
    this.total_amount = this.addBillsForm.get("amount")?.value ?? 0;
  }

  calculateTotal(){
    let sgst = this.addBillsForm.get("sgst_per")?.value ? parseInt(this.addBillsForm.get("sgst_per")?.value) : 0;
    let cgst = this.addBillsForm.get("cgst_per")?.value ? parseInt(this.addBillsForm.get("cgst_per")?.value) : 0;
    let discount = this.addBillsForm.get("discount_per")?.value ? parseInt(this.addBillsForm.get("discount_per")?.value) : 0;
    let amount = this.addBillsForm.get("amount")?.value ? parseInt(this.addBillsForm.get("amount")?.value) :  0;
    let total_sgst = amount * (sgst/100) , total_cgst = amount * (cgst/100);
    let total_discount = amount * (discount/100);
    this.total_amount = (amount + total_sgst + total_cgst) - total_discount;
  }

  payWithRazorpay(billId : string) {
    console.log("Paying with Razorpay for bill ID:", billId);
    this.initiatePaymentSubscription = this.httpService.initiatePayment(this.propertyId, billId, {}).subscribe((response) =>{
      let paymentInfo = response.data["paymentIntent"] ? response.data["paymentIntent"] : "";
      paymentInfo.billId = billId;
      this.initiatePayment(paymentInfo);
    });
  }
  initiatePayment(paymentInfo : any){
    console.log(paymentInfo);
    const options: any = {
      key: APP_CONSTANTS.PAYMENT_KEY, // Replace with your Razorpay key
      amount: paymentInfo.amount, // Amount in paise = INR 500
      currency: paymentInfo.currency,
      name: paymentInfo.paymentName,
      description: paymentInfo.description,
      // image: 'https://yourlogo.url/logo.png',
      order_id: paymentInfo.gatewayId, // Use a real order_id from backend for real payments
      handler: this.handlePaymentSuccess.bind(this, paymentInfo),
      modal: {
        ondismiss: () => {
          console.warn('Payment popup closed by user');
          // Optional: notify user or log event
        }
      },
      prefill: paymentInfo.prefill,
      notes: {
        transactionId: paymentInfo.transactionId
      },
      theme: {
        color: '#3399cc'
      }
    };
    const razorpay = new (window as any).Razorpay(options);

    razorpay.on('payment.failed', this.handlePaymentFailure.bind(this, paymentInfo));
    razorpay.open();
  }

  handlePaymentSuccess(paymentInfo : any, response: any) {
    console.log('Payment Success:', response);
    console.log('paymentInfo ', paymentInfo);
    // alert(`✅ Payment Successful!\nPayment ID: ${response.razorpay_payment_id}`);
    // Optionally: send response to your server for verification
    const payload = {
      payment_id: response.razorpay_payment_id,
      order_id: response.razorpay_order_id,
      signature: response.razorpay_signature,
      uid : paymentInfo.uid,
      status : "success"
    };
    this.allBills.order_id  = response.razorpay_order_id;
    this.allBills.transaction_id = response.razorpay_payment_id;
    this.verifyPaymentSubscription = this.httpService.verifyRazorpaySignature(this.propertyId, paymentInfo.billId, payload).subscribe({
      next: (res) => {
        this.propertyBills.getAllBills();
        this.viewBillDetails();
        this.alertService.success(res.message, 'toast-top-right');
        // Optionally: update bill status or notify user
        // this.addBillsForm.patchValue({ status: 'paid', transaction_id: response.razorpay_payment_id });
        // this.editBill(this.addBillsForm.get("uid")?.value ?? "");
      }
    });
  }

  handlePaymentFailure(paymentInfo : any, response: any) {
    console.error('Payment Failed:', response);
    let data = { ...response.error, ...response.error?.["metadata"], status : "failed", uid : paymentInfo.uid };
    delete data?.metadata;
    this.verifyPaymentSubscription = this.httpService.verifyRazorpaySignature(this.propertyId, paymentInfo.billId, data).subscribe((resp) => {
      this.alertService.error(resp.message, 'toast-top-right');
    });
    // alert(`❌ Payment Failed!\nReason: ${response.error.description || 'Unknown error'}`);
    // Optionally: log the error or retry
  }

  viewVideoUrl(url : string){
    if(!url) return;
    window.open(url , "_blank");
  }

  updateInvoiceDateValidation() {
    const invoiceDateControl = this.addBillsForm.get('invoice_date');
    const status = this.addBillsForm.get('status')?.value;
    const isTaxable = this.addBillsForm.get('taxable')?.value ?? false;

    if (status === 'Paid' && isTaxable) {
      invoiceDateControl?.setValidators([Validators.required]);
    } else {
      invoiceDateControl?.clearValidators();
    }
    invoiceDateControl?.updateValueAndValidity();
  }

  onStatusChange() {
    this.updateInvoiceDateValidation();
  }

  get displayTaxDetails(){
     const isTaxable = this.addBillsForm.get("taxable")?.value ?? false;
     if(!isTaxable){
       this.addBillsForm.patchValue({
        cgst_per : 0,
        sgst_per : 0
       });
     }
     return isTaxable;
  }



  ngOnDestroy() {
    this.routeSubscription?.unsubscribe();
    this.getCategoriesSubscription?.unsubscribe();
    this.getBankAccountsSubscription?.unsubscribe();
    this.getBillDetailsSubscription?.unsubscribe();
    this.editBillSubscription?.unsubscribe();
    this.deleteBillImageSubscription?.unsubscribe();
    this.getBillImagesSubscription?.unsubscribe();
    this.addDocumentSubscription?.unsubscribe();
    this.getAllDocumentsSubscription?.unsubscribe();
    this.deleteDocumentSubscription?.unsubscribe();
    this.getAllPropertyImagesSubscription?.unsubscribe();
    this.getPropertyDetailsByIdSubscription?.unsubscribe();
    this.getAllPropertyRoomsSubscription?.unsubscribe();
    this.initiatePaymentSubscription?.unsubscribe();
    this.queryParamsSubsscription?.unsubscribe();
  }

  get checkPropertyEdit() {
    return this.authService.checkPermission(USER_PERMISSIONS.PROPERTIES.PROPERTY_EDIT);
  }

  get checkPropertyDetailsTab() {
    return this.authService.checkPermission(USER_PERMISSIONS.PROPERTIES.PROPERTY_DETAILS_TAB);
  }

  get checkPropertyRoomsTab() {
    return this.authService.checkPermission(USER_PERMISSIONS.PROPERTIES.PROPERTY_ROOMS_TAB);
  }

  get checkPropertyAmenitiesTab() {
    return this.authService.checkPermission(USER_PERMISSIONS.PROPERTIES.PROPERTY_AMENITIES_TAB);
  }

  get checkPropertyImagesTab() {
    return this.authService.checkPermission(USER_PERMISSIONS.PROPERTIES.PROPERTY_IMAGES_TAB);
  }

  get checkPropertyBillsTab() {
    return this.authService.checkPermission(USER_PERMISSIONS.PROPERTIES.PROPERTY_BILLS_TAB);
  }

  get checkPropertyDocumentsTab() {
    return this.authService.checkPermission(USER_PERMISSIONS.PROPERTIES.PROPERTY_DOCUMENTS_TAB);
  }

  get checkBuyerDetailsTab() {
    return this.authService.checkPermission(USER_PERMISSIONS.PROPERTIES.PROPERTY_BUYER_DETAILS_TAB);
  }

  get checkPropertyLeaseTab() {
    return this.authService.checkPermission(USER_PERMISSIONS.PROPERTIES.PROPERTY_LEASES_TAB);
  }

  get checkPropertyEnquiriesTab() {
    return this.authService.checkPermission(USER_PERMISSIONS.PROPERTIES.PROPERTY_ENQUIRIES_TAB);
  }

  get checkPropertyTasksTab() {
    return this.authService.checkPermission(USER_PERMISSIONS.TASKS.TASKS_PAGE);
  }

  get checkEditBill() {
    return this.authService.checkPermission(USER_PERMISSIONS.PROPERTIES.EDIT_BILL);
  }

  get checkAddDocument() {
    return this.authService.checkPermission(USER_PERMISSIONS.PROPERTIES.ADD_DOCUMENT);
  }

  get checkViewDocument() {
    return this.authService.checkPermission(USER_PERMISSIONS.PROPERTIES.VIEW_DOCUMENT);
  }

  get checkDeleteDocument() {
    return this.authService.checkPermission(USER_PERMISSIONS.PROPERTIES.DELETE_DOCUMENT);
  }



}
